(() => {
  if (window.Shopify?.designMode || !('IntersectionObserver' in window) || !Element.prototype.animate) return;

  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const running = new Set();
  const targets = '.s9-hero__copy, .s9-head, .s9-tile, .s9-pcard, .s9-story, .s9-amb, .s9-community__header, .s9-community__photo';
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      observer.unobserve(target);
      if (preference.matches) return;
      seen.add(target);

      const animation = target.animate(
        [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 480, easing: 'cubic-bezier(.2,.7,.3,1)' }
      );
      running.add(animation);
      animation.finished.catch(() => {}).finally(() => running.delete(animation));
    });
  }, { threshold: 0.08 });

  const observe = () => {
    if (preference.matches || !document.querySelector('.s9[data-s9-motion="true"]')) return;
    document.querySelectorAll(targets).forEach((target) => {
      if (seen.has(target)) return;
      observer.observe(target);
    });
  };

  preference.addEventListener('change', () => {
    if (preference.matches) {
      observer.disconnect();
      running.forEach((animation) => animation.cancel());
    } else observe();
  });
  document.addEventListener('shopify:section:load', observe);
  observe();
})();
